
import { TranslationsByLanguage, PluralTranslation } from './types';

export type PlaylistsTranslationKey =
  | 'playlists.allPlaylists'
  | 'playlists.searchPlaceholder'
  | 'playlists.clips'
  | 'playlists.description'
  | 'playlists.view'
  | 'playlist.createdBy'
  | 'playlist.clips'
  | 'playlist.playAll'
  | 'playlist.download'
  | 'playlist.view'
  | 'playlist.notFound'
  | 'playlist.notFoundDescription'
  | 'playlist.clipCount'
  | 'explore.playlists.title'
  | 'explore.playlists.description'
  | 'playlists.noPlaylists';

export const playlistsTranslations: TranslationsByLanguage = {
  en: {
    'playlists.allPlaylists': 'All Playlists',
    'playlists.searchPlaceholder': 'Search playlists...',
    'playlists.clips': 'clips',
    'playlists.description': 'Explore curated collections of clips.',
    'playlists.view': 'View Playlist',
    'playlist.createdBy': 'Created by',
    'playlist.clips': 'clips',
    'playlist.playAll': 'Play All',
    'playlist.download': 'Download All',
    'playlist.view': 'View',
    'playlist.notFound': 'Playlist Not Found',
    'playlist.notFoundDescription': 'The playlist you\'re looking for doesn\'t exist or has been removed.',
    'playlist.clipCount': {
      zero: 'No clips',
      one: '1 clip',
      other: '{count} clips'
    } as PluralTranslation,
    'explore.playlists.title': 'Curated Content Collections',
    'explore.playlists.description': 'Browse our carefully selected collections of premium video content',
    'playlists.noPlaylists': 'No playlists found.'
  },
  fr: {
    'playlists.allPlaylists': 'Toutes les Playlists',
    'playlists.searchPlaceholder': 'Rechercher des playlists...',
    'playlists.clips': 'clips',
    'playlists.description': 'Explorez des collections organisées de clips.',
    'playlists.view': 'Voir la Playlist',
    'playlist.createdBy': 'Créé par',
    'playlist.clips': 'clips',
    'playlist.playAll': 'Tout Lire',
    'playlist.download': 'Tout Télécharger',
    'playlist.view': 'Voir',
    'playlist.notFound': 'Playlist Introuvable',
    'playlist.notFoundDescription': 'La playlist que vous recherchez n\'existe pas ou a été supprimée.',
    'playlist.clipCount': {
      zero: 'Aucun clip',
      one: '1 clip',
      other: '{count} clips'
    } as PluralTranslation,
    'explore.playlists.title': 'Collections de Contenu Organisées',
    'explore.playlists.description': 'Parcourez nos collections soigneusement sélectionnées de contenu vidéo premium',
    'playlists.noPlaylists': 'Aucune playlist trouvée.'
  }
};
